import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AmbientBackground from "./AmbientBackground";

export default function PageShell({ title, subtitle, icon: Icon, accent, children, testid }) {
  return (
    <div className="relative min-h-screen" data-testid={testid}>
      <AmbientBackground theme={accent || { a: "#D4AF37", b: "#5C8A6E", c: "#2E5A66" }} />
      <header className="mx-auto flex max-w-4xl items-center gap-3 px-6 py-6">
        <Link
          to="/"
          data-testid="back-home"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background/60 backdrop-blur-md transition-colors hover:bg-muted"
        >
          <ArrowLeft className="h-4 w-4" />
        </Link>
        <div className="flex items-center gap-3">
          {Icon && (
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/15 text-primary">
              <Icon className="h-5 w-5" />
            </span>
          )}
          <div>
            <h1 className="font-serif-display text-2xl leading-none tracking-tight md:text-3xl">
              {title}
            </h1>
            {subtitle && (
              <p className="font-ui mt-1 text-sm text-muted-foreground">{subtitle}</p>
            )}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-6 pb-28">{children}</main>
    </div>
  );
}
